/**
 * Field Order Configuration for Forms
 * Defines the display order for extracted data to match the form layout
 */

export const W8BEN_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Form_number",
  "FormName",
  "Form_revision_date",

  // Part I: Identification of Beneficial Owner
  "Beneficial Owner name",
  "First name and middle name",
  "Last name",
  "Country of citizenship",
  "Other",

  // Permanent Address
  "Permanent residence address",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent city address",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address zip",
  "Permanent address country",
  "Permanent address other",
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Mailing Address
  "Mailing address",
  "Mailing address line 2",
  "Mailing address line 3",
  "Mailing address city",
  "Mailing city address",
  "Mailing address state USCA",
  "Mailing address state NonUS",
  "Mailing address zip",
  "Mailing address country",
  "Mailing address other",
  "Mailing address is care of",
  "Mailing address is po box",
  "Mailing address is rural route",

  // Part II: Claim of Tax Treaty Benefits
  "U.S. taxpayer identification number",
  "Taxpayer type",
  "Foreign tax identifying number",
  "Reference number",
  "W8BEN-FTIN_not_required",
  "W8BEN-Reference_numbers",
  "Date of birth",
  // Treaty Claims (will be handled separately)
  "W8BEN-Treaty_country",
  "W8BEN-Treaty_article",
  "W8BEN-Treaty_withholding_rate",
  "W8BEN-Treaty_income_type",
  "W8BEN-Treaty_conditions_explanation",
  "W8BEN-Treaty_country_0",
  "W8BEN-Treaty_article_0",
  "W8BEN-Treaty_withholding_rate_0",
  "W8BEN-Treaty_income_type_0",
  "W8BEN-Treaty_conditions_explanation_0",
  "Treaty_other_0",
  "Treaty_paragraph_0",
  "Treaty_subparagraph_0",
  "Signature_capacity",
  "isSigned",
  "isModified",
  "Signature",
  "Signer_printed_name",
  "Signature_date",
  "Signature_unreadable",
];

export const W8BENE_FIELD_ORDER = [
  // Part I: Identification
  "UniqueIdentifier",
  "Name of organization",
  "Country of incorporation or organization",
  "Other",
  "W8-BENE-Name_of_disregarded_entity",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  // "Entity Type",
  // "Chapter4Status",
  "Form_name",
  "Form_revision_date",

  // Part II: Chapter 3 Status (Entity Type)
  "W8-BENE-4_central_bank",
  "W8-BENE-4_complex_trust",
  "W8-BENE-4_corporation",
  "W8-BENE-4_disregarded_entity",
  "W8-BENE-4_estate",
  "W8-BENE-4_foreign_government_controlled_entity",
  "W8-BENE-4_foreign_government_integral_part",
  "W8-BENE-4_grantor_trust",
  "W8-BENE-4_international_organization",
  "W8-BENE-4_partnership",
  "W8-BENE-4_private_foundation",
  "W8-BENE-4_simple_trust",
  "W8-BENE-4_tax_exempt_organization",
  "W8-BENE-4_hybrid_treaty_claim",
  "W8-BENE-4_hybrid_treaty_claim_yes",
  "W8-BENE-4_hybrid_treaty_claim_no",

  // Part III: Chapter 4 Status (FATCA)
  "W8-BENE-5_fatca_501c_org_",
  "W8-BENE-5_account_not_financial",
  "W8-BENE-5_active_nffe",
  "W8-BENE-5_investment_entities",
  "W8-BENE-5_certified_low_value",
  "W8-BENE-5_certified_limited_life",
  "W8-BENE-5_certified_local_bank",
  "W8-BENE-5_certified_sponsored",
  "W8-BENE-5_direct_reporting",
  "W8-BENE-5_entity_exempt_owners",
  "W8-BENE-5_excepted_affiliate",
  "W8-BENE-5_excepted_liquidation",
  "W8-BENE-5_excepted_group",
  "W8-BENE-5_excepted_startup",
  "W8-BENE-5_excepted_territory",
  "W8-BENE-5_exempt_retirement",
  "W8-BENE-5_foreign_government",
  "W8-BENE-5_international_organization",
  "W8-BENE-5_nonparticipating_ffi",
  "W8-BENE-5_nonprofit_org",
  "W8-BENE-5_nonreporting_iga",
  "W8-BENE-5_owner_documented",
  "W8-BENE-5_participating_ffi",
  "W8-BENE-5_passive_nffe",
  "W8-BENE-5_publicly_traded",
  "W8-BENE-5_registered_deemed",
  "W8-BENE-5_reporting_model1",
  "W8-BENE-5_reporting_model2",
  "W8-BENE-5_restricted_distributor",
  "W8-BENE-5_sponsored_direct",
  "W8-BENE-5_sponsored_ffi",
  "W8-BENE-5_territory_financial",

  // Part IV: Permanent Residence Address
  "Permanent residence address",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent city address",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address zip",
  "Permanent address country",
  "Permanent address other",
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Part V: Mailing Address
  "Mailing address",
  "Mailing address line 2",
  "Mailing address line 3",
  "Mailing address city",
  "Mailing city address",
  "Mailing address state USCA",
  "Mailing address state NonUS",
  "Mailing address zip",
  "Mailing address country",
  "Mailing address other",
  "Mailing address is care of",
  "Mailing address is po box",
  "Mailing address is rural route",

  // Part VI: Tax Identification
  "Taxpayer type",
  "U.S. taxpayer identification number",
  "GIINCheckBox",
  "GIIN",
  "GIIN Applied For",
  "Foreign TIN",
  "W8-BENE-Foreign_tax_identifying_number",
  "W8-BENE-FTIN_not_legally_required",
  "W8-BENE-10_reference_number",

  // Part 11: Branch Information
  "W8-BENE-11_branch_treated_as_nonparticipating_FFI",
  "W8-BENE-11_participating_FFI",
  "W8-BENE-11_reporting_Model1_FFI",
  "W8-BENE-11_reporting_Model2_FFI",
  "W8-BENE-11_us_branch",

  // Part 12: Disregarded Entity Information
  "W8-BENE-12_disregarded_entity_address",
  "W8-BENE-12_disregarded_entity_city_state_postal",
  "W8-BENE-12_disregarded_entity_country",

  // Part 13: GIIN
  "W8-BENE-13_giin",

  // Part 14-15: Treaty Benefits and Special Certifications
  "W8-BENE-14A_beneficial_owner_resident",
  "W8-BENE-14A_country_name",
  "W8-BENE-14B_beneficial_owner_derives_item",
  "W8-BENE-14B_government",
  "W8-BENE-14B_tax_exempt_pension_trust",
  "W8-BENE-14B_other_tax_exempt_organization",
  "W8-BENE-14B_publicly_traded_corporation",
  "W8-BENE-14B_subsidiary_of_publicly_traded",
  "W8-BENE-14B_company_meets_ownership_and_base_erosion_test",
  "W8-BENE-14B_company_meets_derivative",
  "W8-BENE-14B_company_meets_active_trade_or_business",
  "W8-BENE-14B_favorable_discretionary_determination",
  "W8-BENE-14B_no_lob",
  "W8-BENE-14B_other",
  "W8-BENE-14B_other_text",
  "W8-BENE-14C_claiming_treaty_benefits",
  "W8-BENE-15_treaty_provision_and_paragraph",
  "W8-BENE-15_withholding_rate_percentage",
  "W8-BENE-15_income_type",
  "W8-BENE-15-Treaty_article_0",
  "W8-BENE-15-Treaty_paragraph_0",
  "W8-BENE-15-Treaty_subparagraph_0",
  "W8-BENE-15-Treaty_percentage_0",
  "W8-BENE-15-Treaty_typeOfIncome_0",
  "W8-BENE-15_additional_conditions_explaination",

  // Part 16-20: Sponsoring Entity and Investment Information
  "W8-BENE-16_name_of_sponsoring_entity",
  "W8-BENE-17_investment_entity",
  "W8-BENE-17_controlled_foreign_corporation",
  "W8-BENE-18_licensed_solely",
  "W8-BENE-19_investing_reinvesting_or_trading",
  "W8-BENE-20_sponsoring_entity_name",

  // Part 21-26: Additional FFI and Entity Certifications
  "W8-BENE-21_qi_wp_wt",
  "W8-BENE-22_january_17_2013",
  "W8-BENE-23_section_1_1471",
  "W8-BENE-24A_owner_documented_FFI",
  "W8-BENE-24B_FFI_owner_reporting",
  "W8-BENE-24C_auditor_letter",
  "W8-BENE-24D_contingent_beneficiaries",
  "W8-BENE-25A_restricted_distributors",
  "W8-BENE-25B_restricted_distributor_bound_agreement",
  "W8-BENE-25C_restricted_distributor_current_agreement",
  "W8-BENE-26_nonreporting_iga_country",
  "W8-BENE-26_treated_as",
  "W8-BENE-26_country_name",
  "W8-BENE-26_model1_iga",
  "W8-BENE-26_model2_iga",
  "W8-BENE-26_trustee_sponsor_name",
  "W8-BENE-26_trustee_us",
  "W8-BENE-26_trustee_foreign",

  // Part 27-43: Government, Retirement, NFFE and Other Certifications
  "W8-BENE-27_foreign_government_checkbox",
  "W8-BENE-28A_international_org_7701_checkbox",
  "W8-BENE-28B_international_org_intergovernmental",
  "W8-BENE-29A_retirement_plan_treaty",
  "W8-BENE-29B_retirement_plan_organized",
  "W8-BENE-29C_retirement_plan_fewer_50",
  "W8-BENE-29D_retirement_plan_401a",
  "W8-BENE-29E_retirement_plan_earn_income",
  "W8-BENE-29F_retirement_plan_government_sponsored",
  "W8-BENE-30_entity_wholly_owned",
  "W8-BENE-31_territory_financial_institution",
  "W8-BENE-32_excepted_nonfinancial_group",
  "W8-BENE-33_excepted_startup",
  "W8-BENE-33_excepted_startup_formation_date",
  "W8-BENE-34_excepted_liquidation",
  "W8-BENE-34_excepted_liquidation_filing_date",
  "W8-BENE_35_section_501c",
  "W8-BENE-35_section_501c_determination_date",
  "W8-BENE-36_nonprofit_organization",
  "W8-BENE-37A_publicly_traded_nffe",
  "W8-BENE-37A_securities_exchange_name",
  "W8-BENE-37B_nffe_affiliate",
  "W8-BENE-37B_entity_name",
  "W8-BENE-37B_name_of_securities",
  "W8-BENE-38_excepted_territory_nffe",
  "W8-BENE-39_active_nffe",
  "W8-BENE-40A_traded_nffe",
  "W8-BENE-40B_passive_nffe_no_substantial_owners",
  "W8-BENE-40C_passive_nffe_substantial_owners_provided",
  "W8-BENE-41_affiliated_group",
  "W8-BENE-42_sponsoring_entity",
  "W8-BENE-43_nffe",

  // Substantial Owners (Part 40C)
  "W8-BENE-substantial_owner_1_name",
  "W8-BENE-substantial_owner_1_address",
  "W8-BENE-substantial_owner_1_tin",
  "W8-BENE-substantial_owner_2_name",
  "W8-BENE-substantial_owner_2_address",
  "W8-BENE-substantial_owner_2_tin",
  "W8-BENE-substantial_owner_3_name",
  "W8-BENE-substantial_owner_3_address",
  "W8-BENE-substantial_owner_3_tin",
  "W8-BENE-substantial_owner_4_name",
  "W8-BENE-substantial_owner_4_address",
  "W8-BENE-substantial_owner_4_tin",
  "W8-BENE-substantial_owner_5_name",
  "W8-BENE-substantial_owner_5_address",
  "W8-BENE-substantial_owner_5_tin",
  "W8-BENE-substantial_owner_6_name",
  "W8-BENE-substantial_owner_6_address",
  "W8-BENE-substantial_owner_6_tin",
  "W8-BENE-substantial_owner_7_name",
  "W8-BENE-substantial_owner_7_address",
  "W8-BENE-substantial_owner_7_tin",
  "W8-BENE-substantial_owner_8_name",
  "W8-BENE-substantial_owner_8_address",
  "W8-BENE-substantial_owner_8_tin",
  "W8-BENE-substantial_owner_9_name",
  "W8-BENE-substantial_owner_9_address",
  "W8-BENE-substantial_owner_9_tin",
  "W8-BENE-substantial_owner_10_name",
  "W8-BENE-substantial_owner_10_address",
  "W8-BENE-substantial_owner_10_tin",

  // Signature and Certification
  "Signing_capacity",
  "isSigned",
  "isModified",
  "Signature",
  "Signer_printed_name",
  "Signature_date",
  "Signature_unreadable",
];

export const W9_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Entity Type",
  "Form_number",
  "FormName",
  "Form_revision_date",

  // Part I: Identification of Beneficial Owner
  "First name and middle name",
  "Last name",
  "Name of organization",
  "W9-Business_name",
  "Country_of_incorporation/organization",

  // Tax Classification
  "W9-Tax_classification_c_corporation",
  "W9-Tax_classification_individual_sole_proprietor",
  "W9-Tax_classification_llc",
  "W9-Tax_classification_partnership",
  "W9-Tax_classification_trust_estate",
  "W9-Tax_classification_s_corporation",
  "W9-Tax_classification_other",
  "W9-Tax_classification_other_description",
  "W9_Tax_classification_llc_value",
  "W9-Tax_classification_llc_value",

  // Federal Tax Classification
  "W9-Federal_s_corporation",
  "W9-Federal_c_corporation",
  "W9-Federal_partnership",

  // Foreign Partners Question
  "W9-3B_foreign_partners",
  "foreign_partners",

  // Chapter 4 Status
  "Chapter4Status",

  // Permanent Address
  "Permanent residence address",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent city address",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address state",
  "Permanent address zip",
  "Permanent address country",
  "Permanent address other",

  // Address Type Checkboxes
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Taxpayer Identification
  "Taxpayer email",
  "Taxpayer type",
  "Employer identification number",
  "Social security number",
  "Taxpayer applied for",

  // Other Information
  "W9-Exempt_payee_code",
  "Exempt payee multiple",
  "Exempt payee multiple text",
  "Exempt payee unknown",
  "W9-Fatca_exemption_code",
  "FATCA multiple",
  "FATCA multiple text",
  "FATCA unknown",
  "W9-Requester_name_address",
  "W9-Account_numbers",

  // Part II: Certification
  "needToBeSigned",
  "isPartII2aCrossedOut",
  "isPartII2bCrossedOut",
  "isPartII2cCrossedOut",
  "isSigned",
  "isModified",
  "Print_name",
  "Signature",
  "Signature_date",
  "Signature_unreadable",
];

export const W8IMY_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Entity Type",
  "Chapter4Status",
  "Form_name",
  "Form_revision",

  // Part I: Identification of Entity
  "Name of organization",
  "Country_of_incorporation_organization",
  "Other",
  "IMY-Disregarded_entity_name",

  // Chapter 3 Status (Entity Type)
  "IMY-4_Non_qualified_intermediary",
  "IMY-4_Non_withholding_foreign_grantor_trust",
  "IMY-4_Non_withholding_foreign_partnership",
  "IMY-4_Non_withholding_foreign_simple_trust",
  "IMY-4_QI",
  "IMY-4_Territory_financial_institution",
  "IMY-4_US_branch",
  "IMY-4_Withholding_foreign_partnership",
  "IMY-4_Withholding_foreign_trust",

  // Chapter 4 Status (FATCA Status)
  "IMY-5_active_NFFE",
  "IMY-5_certain_investment_entities",
  "IMY-5_certified_deemed_low_value",
  "IMY-5_certified_deemed_debt_entity",
  "IMY-5_certified_deemed_local_bank",
  "IMY-5_certified_deemed_investment_vehicle",
  "IMY-5_direct_reporting_NFFE",
  "IMY-5_excepted_non_financial_liquidation",
  "IMY-5_excepted_non_financial_group",
  "IMY-5_excepted_non_financial_startup",
  "IMY-5_excepted_territory_NFFE",
  "IMY-5_exempt_retirement_plans",
  "IMY-5_foreign_central_bank",
  "IMY-5_non_participating_FFI",
  "IMY-5_non_reporting_IGA_FFI",
  "IMY-5_owner_documented_FFI",
  "IMY-5_participating_FFI",
  "IMY-5_passive_NFFE",
  "IMY-5_publicly_traded_NFFE",
  "IMY-5_registered_deemed_compliant_FFI",
  "IMY-5_reporting_model1_FFI",
  "IMY-5_reporting_model2_FFI",
  "IMY-5_restricted_distributor",
  "IMY-5_sponsored_direct_reporting_NFFE",
  "IMY-5_sponsored_FFI",
  "IMY-5_territory_financial_institution",

  // Permanent Address
  "Permanent residence address",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent city address",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address zip",
  "Permanent address country",
  "Permanent address other",
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Mailing Address
  "Mailing address",
  "Mailing address line 2",
  "Mailing address line 3",
  "Mailing address city",
  "Mailing city address",
  "Mailing address state USCA",
  "Mailing address state NonUS",
  "Mailing address zip",
  "Mailing address country",
  "Mailing address other",
  "Mailing address is care of",
  "Mailing address is po box",
  "Mailing address is rural route",

  // Taxpayer Identification
  "Taxpayer type",
  "IMY-8_us_tin",
  "IMY-8_us_tin_qi_ein",
  "IMY-8_us_tin_wp_ein",
  "IMY-8_us_tin_wt_ein",
  "IMY-8_us_tin_ein",
  "GIINCheckBox",
  "IMY-9A_giin",
  "GIIN Applied For",
  "Foreign TIN",
  "IMY-9B_foreign_tax_identifying_number",
  "IMY-10_reference_number",

  // Part II: Disregarded Entity or Branch
  "IMY-11_Branch_non_participating_FFI",
  "IMY-11_Participating_FFI",
  "IMY-11_Reporting_model1_FFI",
  "IMY-11_Reporting_model2_FFI",
  "IMY-11_US_Branch",
  "IMY-12_disregarded_entity_address_of_branch",
  "Disregarded entity line 2",
  "IMY-12_disregarded_entity_city_state_of_branch",
  "IMY-branchCity_State_state",
  "IMY-branchCity_State_postal",
  "IMY-12_disregarded_entity_country_of_branch",
  "IMY-13_disregarded_entity_giin",

  // Part III: Qualified Intermediary
  "IMY-14_Certification_Qualified_Intermediary",
  "IMY-15A_primary_withholding_responsibility",
  "IMY-15B_publicly_traded_partnerships",
  "IMY-15C_withholding_as_nominee",
  "IMY-15D_qualified_securities_lender",
  "IMY-15E_withholding_and_form_1099_reporting",
  "IMY-15F_form_1099_reporting_for_us",
  "IMY-15G_non_assumption_of_form_1099_reporting",
  "IMY-15H_chapter4_withholding_rate_pool",
  "IMY-15I_intermediary_orflow_through_entities",
  "IMY-16A_certification_qdd_meets_requirements",
  "IMY-16B_entity_classification_corporation",
  "IMY-16B_entity_classification_partnership",
  "IMY-16B_entity_classification_disregarded_entity",

  // Part IV: Non-qualified Intermediary
  "IMY-17A_not_acting_as_qi",
  "IMY-17B_transmit_withholding_certificates",
  "IMY-17C_nqi_withholding_rate_pool",
  "IMY-17D_qualified_securities_lender",
  "IMY-17E_alternative_withholding_statement",

  // Part V: Territory Financial Institution
  "IMY-18A_tfi_certification",
  "IMY-18B_tfi_us_person_treatment",
  "IMY-18C_transmit_withholding_certificates",
  "IMY-18D_publicly_traded_partnerships",
  "IMY-18E_us_person_and_nominee",
  "IMY-18F_tfi_not_nominee",

  // Part VI: Certain U.S. Branches
  "IMY-19A_us_branch_certification",
  "IMY-19B_us_branch_agreement",
  "IMY-19C_transmit_certificates",
  "IMY-19D_us_branch_ptp",
  "IMY-19E_us_branch_nominee",
  "IMY-19F_us_branch_not_nominee",

  // Part VII: Withholding Foreign Partnership (WP) or Withholding Foreign Trust (WT)
  "IMY-20_withholding_foreign_partnership",

  // Part VIII: Nonwithholding Foreign Partnership, Simple Trust, or Grantor Trust
  "IMY-21A_foreign_partnership_trust",
  "IMY-21B_lower_tier_partnership",
  "IMY-21C_transfer_of_interest",
  "IMY-21D_statement_for_modified_amount",
  "IMY-21E_behalf_of_grantors",
  "IMY-21F_alternative_withholding_statement",

  // Part IX: Nonparticipating FFI with Exempt Beneficial Owners
  "IMY-22_exempt_beneficial_owners",

  // Part X: Sponsored FFI
  "IMY-23A_name_of_sponsoring_entity",
  "IMY-23B_sponsored_ffi_investment",
  "IMY-23C_controlled_foreign_corporation",

  // Part XI: Owner Documented FFI
  "IMY-24A_owner_documented_ffi",
  "IMY-24B_FFI_owner_reporting_statement",
  "IMY-24C_owner_documented_ffi_auditor",

  // Part XII: Certified Deemed-Compliant Nonregistered Local Bank
  "IMY-25_nonregistering local bank _certification",

  // Part XIII: Certified Deemed-Compliant FFI with Only Low-Value Accounts
  "IMY-26_low_value_accounts",

  // Part XIV: Certified Deemed-Compliant Sponsored, Closely Held Investment Vehicle
  "IMY-27A_sponsored_investment_vehicle_name",
  "IMY-27B_sponsored_investment_vehicle",

  // Part XV: Certified Deemed-Compliant Limited Life Debt Investment Entity
  "IMY-28_limited_life_debt",

  // Part XVI: Certain Investment Entities
  "IMY-29_financial_institution_solely",

  // Part XVII: Restricted Distributor
  "IMY-30A_restricted_distributor",
  "IMY-30B_restricted_distributor_agreement",
  "IMY-30C_restricted_distributor_current",

  // Part XVIII: Foreign Central Bank of Issue
  "IMY-31_central_bank",

  // Part XIX: Nonreporting IGA FFI
  "IMY-32_nonreporting_iga_ffi",
  "IMY-32_iga_country",
  "IMY-32_model1_iga",
  "IMY-32_model2_iga",
  "IMY-32_treated_as",
  "IMY-32_trustee_name",
  "IMY-32_trustee_us",
  "IMY-32_trustee_foreign",

  // Part XX: Exempt Retirement Plans
  "IMY-33A_retirement_plan_treaty",
  "IMY-33B_retirement_plan_employer",
  "IMY-33C_retirement_plan_small",
  "IMY-33D_retirement_plan_401a",
  "IMY-33E_retirement_plan_investment",
  "IMY-33F_retirement_plan_government",

  // Part XXI: Excepted Nonfinancial Group Entity
  "IMY-34_nonfinancial_group_entity",

  // Part XXII: Excepted Nonfinancial Start-Up Company
  "IMY-35_startup_company_certification",
  "IMY-35_startup_formation_date",

  // Part XXIII: Excepted Nonfinancial Entity in Liquidation or Bankruptcy
  "IMY-36_Liquidation_or_bankruptcy",
  "IMY-36_liquidation_filing_date",

  // Part XXIV: Publicly Traded NFFE or NFFE Affiliate
  "IMY-37A_publicly_traded_nffe",
  "IMY-37B_nffe_affiliate",
  "IMY-37B_affiliate_securities_market",

  // Part XXV: Excepted Territory NFFE
  "IMY-38_territory_nffe",

  // Part XXVI: Active NFFE
  "IMY-39_active_nffe",

  // Part XXVII: Passive NFFE
  "IMY-40_passive_nffe",

  // Part XXVIII: Sponsored Direct Reporting NFFE
  "IMY-41_sponsor_name",
  "IMY-42_sponsored_direct_reporting",

  // Part XXIX: Certification
  "isSigned",
  "isModified",
  "Print_name",
  "Signature",
  "Signature_date",
  "Signature_unreadable",
];

export const W8ECI_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Entity Type",
  "Form_name",
  "FormName",
  "Form_revision",

  // Part I: Identification of Beneficial Owner
  "Beneficial Owner name",
  "First name and middle name",
  "Last name",
  "ECI-Disregarded_entity_name",
  "Country_of_incorporation_organization",
  "Other",

  // Entity Type (User Record Types)
  "ECI-Central_bank_of_issue",
  "ECI-Complex_trust",
  "ECI-Corporation",
  "ECI-Estate",
  "ECI-Government_controlled_entity",
  "ECI-Government_integral",
  "ECI-Grantor_trust",
  "ECI-Individual",
  "ECI-International_organization",
  "ECI-Partnership",
  "ECI-Private_foundation",
  "ECI-Simple_trust",
  "ECI-Tax_exempt_organization",

  // Permanent Address
  "Permanent residence address",
  "Permanent_address_line_2",
  "Permanent_address_line_3",
  "Permanent_address_city",
  "Permanent city address",
  "Permanent_address_state_USCA",
  "Permanent_address_state_NonUS",
  "Permanent_address_zip",
  "Permanent_address_country",
  "Permanent address country",
  "Permanent_address_other",
  "Permanent_address_is_care_of",
  "Permanent_address_is_po_box",
  "Permanent_address_is_rural_route",

  // Business Address (Normally in the U.S.)
  "ECI-Business_address_street",
  "ECI-Business_address_line_2",
  "ECI-Business_address_line_3",
  "Business_address_city",
  "Business_address_state_USCA",
  "Business_address_state_NonUS",
  "Business_address_zip",
  "Business_address_country",
  "Business_address_other",
  "Business_address_is_care_of",
  "Business_address_is_po_box",
  "Business_address_is_rural_route",

  // Combined Business Address Field
  "ECI-Business_address_city_state_zip",

  // Taxpayer Identification
  "Taxpayer_email",
  "Taxpayer_type",
  "U.S. taxpayer identification number",
  "ECI-EIN",
  "ECI-Us_tin_SSN/ITIN",
  "ECI-Us_tin_SSN_ITIN",
  "Foreign tax identifying number",
  "FTIN_not_legally_required",
  "ECI-Reference_number",
  "Date of birth",

  // Items of Income (dynamic fields)
  "incomeItems",
  "ECI_income_type_0",
  "ECI_income_text_0",
  "ECI_income_amount_0",
  "ECI_income_type_1",
  "ECI_income_text_1",
  "ECI_income_amount_1",
  "ECI_income_type_2",
  "ECI_income_text_2",
  "ECI_income_amount_2",
  "ECI_income_type_3",
  "ECI_income_text_3",
  "ECI_income_amount_3",
  "ECI_income_type_4",
  "ECI_income_text_4",
  "ECI_income_amount_4",
  "incomeType",
  "incomeText",
  "incomeAmount",

  // Effectively Connected Income Details
  "ECI-11_Effectively_connected_income_details",

  // Securities Dealer Certification
  "ECI-12_Securities_dealer",

  // Part II: Certification
  "Signing_capacity",
  "isSigned",
  "isModified",
  "Print_name",
  "Signature",
  "Signature_date",
  "Signature_unreadable",
];

export const W8EXP_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Entity Type",
  "Chapter4Status",
  "Form_name",
  "Form_revision",

  // Part I: Identification of Beneficial Owner
  "Name of organization",
  "Country_of_incorporation_organization",
  "Other",

  // Chapter 3 Status (Entity Type)
  "EXP-Foreign_central_bank_issue",
  "EXP-Foreign_government",
  "EXP-Foreign_private_foundation",
  "EXP-Foreign_tax-exempt_organization",
  "EXP-Government_of_us_territory",
  "EXP-International_organization",
  "EXP-Withholding_qualified_holder",

  // Chapter 4 Status (FATCA Status)
  "EXP-501c_organization",
  "EXP-Direct_reporting_NFFE",
  "EXP-Exempt_retirement_plan",
  "EXP-4_foreign_government_central_bank",
  "EXP-4_international_organization",
  "EXP-Nonreporting_IGA_FFI",
  "EXP-Participating_FFI",
  "EXP-Passive_NFFE",
  "EXP-Registered_deemed_compliant_FFI",
  "EXP-Reporting_Model1_FFI",
  "EXP-Reporting_Model2_FFI",
  "EXP-Sponsored_direct_reporting_NFFE",
  "EXP-Territory_financial_institution",

  // Permanent Address
  "Permanent residence address",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address zip",
  "Permanent address country",
  "Permanent address other",
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Combined Permanent Address Field
  "EXP-Permanent_address_city_state_postal",

  // Mailing Address
  "EXP-Mailing_address_street",
  "Mailing address line 2",
  "Mailing address line 3",
  "Mailing city address",
  "Mailing address state USCA",
  "Mailing address state NonUS",
  "Mailing address zip",
  "EXP-Mailing_address_country",
  "Mailing address other",
  "Mailing address is care of",
  "Mailing address is po box",
  "Mailing address is rural route",

  // Combined Mailing Address Field
  "EXP-Mailing_address_city_state_postal",

  // Taxpayer Identification
  "Taxpayer type",
  "U.S. taxpayer identification number",
  "GIINCheckBox",
  "GIIN",
  "GIIN Applied For",
  "Foreign TIN",
  "Foreign tax identifying number",
  "EXP-Reference_numbers",

  // Part II: Qualification Statement for Chapter 3 Status
  // Line 10 - For a foreign government
  "EXP-10A_Foreign_government",
  "EXP-10B_Integral_part",
  "EXP-10B_Integral_part_government_name",
  "EXP-10B_Integral_part_government_name_other",
  "EXP-10C_Controlled_entity",
  "EXP-10C_Controlled_entity_government_name",
  "EXP-10C_Controlled_entity_government_name_other",
  "EXP-10D_Not_commercial_activities",
  "EXP-10E_Central_bank_not_us_commercial",

  // Line 11 - For an international organization
  "EXP-11_International_organization",

  // Line 12 - For a foreign central bank of issue
  "EXP-12_Foreign_central_bank",

  // Line 13 - For a foreign tax-exempt organisation
  "EXP-13A_Irs_determination",
  "EXP-13A_tax_exempt_determination_letter_date",
  "EXP-13B_Us_counsel_opinion",
  "EXP-13C_Not_private_foundation",
  "EXP-13D_Is_private_foundation",

  // Line 14 - For a government of a U.S. territory
  "EXP-14_Us_territory_government",

  // Line 15 - For a withholding qualified holder
  "EXP-15A_Qualified_holder",
  "EXP-15B_Foreign_partnership_qualified_holders",

  // Part III: Qualification Statement for Chapter 4 Status
  // Line 16 - For a nonreporting IGA FFI
  "EXP-16_Nonreporting_IGA_FFI",
  "EXP-16_nonreporting_iga_ffi_country",
  "EXP-16_nonreporting_iga_ffi_treatment",
  "EXP-16_nonreporting_iga_ffi_giin",

  // Line 17 - For a territory financial institution
  "EXP-17_Territory_financial_institution",

  // Line 18 - For a foreign government
  "EXP-18_Foreign_government_fatca",

  // Line 19 - For an exempt retirement plan
  "EXP-19A_Retirement_plan_employees",
  "EXP-19B_Entity_identitfier",

  // Line 20 - For a 501(c) organization
  "EXP-20_501c_Organization_fatca",

  // Line 21 - For a passive NFFE
  "EXP-21A_Passive_nffe_certification",
  "EXP-21B_No_substantial_us_owners",
  "EXP-21C_Has_substantial_us_owners",

  // Line 22 - Sponsored direct reporting
  "EXP-22_Sponsored_direct_reporting",
  "EXP-22_sponsoring_entity_name",

  // Part IV: Certification
  "Signing_capacity",
  "isSigned",
  "isModified",
  "Print_name",
  "Signature",
  "Signature_date",
  "Signature_unreadable",
];

export const FORM_8233_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Form_name",
  "Form_revision_date",
  "Form-8233-Calendar_year",
  "Form-8233-Beginning_year",
  "Form-8233-Ending_year",
  // Personal Information
  "Form-8233-Part_1_individual_name",

  "Form-8233-Part_1_us_tax_id",
  "Form-8233-Part_1_ftin",

  // Permanent Address
  "Form-8233-Part_1_permanent_address_street",
  "Permanent address line 2",
  "Permanent address line 3",
  "Permanent address city",
  "Permanent address state USCA",
  "Permanent address state NonUS",
  "Permanent address zip",
  "Form-8233-Part_1_permanent_address_country",
  "Permanent address other",
  "Permanent address is care of",
  "Permanent address is po box",
  "Permanent address is rural route",

  // Combined Address Fields (for extraction)
  "Form-8233-Part_1_permanent_address_city_state_postal",
  "Permanent_address_city_state_postal",

  // Address in United States
  "Form-8233-Part_1_us_address_street",
  "US address line 2",
  "US address line 3",
  "US address city",
  "US address state USCA",
  "US address state NonUS",
  "US address zip",
  "US address country",
  "US address other",
  "US address is care of",
  "US address is po box",
  "US address is rural route",

  // Combined US Address Fields (for extraction)
  "Form-8233-Part_1_us_address_city_state_zip",
  "8233_US_Address_city/state/town/ZC",

  // Taxpayer Identification
  "Email",
  "Taxpayer type",

  // Other Part I Information
  "Form-8233-Part_1_us_visa_type",
  "Form-8233-Part_1_passport_country",
  "Other",
  "Form-8233-Part_1_passport_number",
  "Form-8233-Part_1_date_entry_to_us",
  "Form-8233-Part_1_current_nonimmigrant_status",
  "Current nonimmigrant status Not Applicable",
  "Form-8233-Part_1_current_nonimmigrant_status_expires",
  "Form-8233-Part_1_foreign_student_trainee_researcher",

  // Part II - Section 11: Compensation for Independent Personal Services
  "Form-8233-Part_2_personal_services",
  "Form-8233-Part_2_total_compensation_expected",

  // Part II - Section 12: Tax Treaty Exemption
  "Form-8233-Part_2_tax_treaty",
  "Form-8233-Part_2_treaty_article",
  "Form-8233-Part_2_total_compensation_listed_tax_under_treaty",
  "12_All is exempt from tax",
  "Form-8233-Part_2_country_residence",
  "12d_Other",

  // Part II - Section 13: Noncompensatory Scholarship or Fellowship Income
  "Form-8233-Part_2_scholarship_amount",
  "8233_13c_Treaty_article(scholarship)",
  "Form-8233-Part_3_scholarship_total_income_under_treaty",

  // Part II - Section 14: Sufficient Facts

  "Form-8233-Part_3_scholarship_tax_treaty",

  "Form-8233-Part_3_scholarship_treaty_article",
  "Form-8233-Part_2_sufficient_facts",
  "Form-8233-Part_3_signature_date",

  // Part IV - Withholding Agent Information
  "Form-8233-Part_4_withholding_name",
  "Form-8233-Part_4_eid",
  "Form-8233-Part_4_address_street",
  "Form-8233-Part_4_address_city_state_zip",
  "Form-8233-Part_4_telephone_number",
  "Form-8233-Part_4_signature",
  "Form-8233-Part_4_signature_date",

  // Certification
  "isSigned",
  "isModified",
  "Form-8233-Part_3_signature",
  "Signature",
  "Signature_unreadable",
];

export const SELF_CERT_INDIVIDUAL_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Form_name",

  // Section I - Identification of Individual
  "SC-Individual-Title",
  "SC-Individual-Last_name",
  "SC-Individual-First_name",
  "SC-Individual-Middle_name",
  "SC-Individual-City_of_birth",
  "SC-Individual-Country_of_birth",
  "SC-Individual-Date_of_birth",

  // Section I - Current Residence Address
  "SC-Individual-Current_residence_address_street",
  "SC-Individual-Current_residence_address_city",
  "SC-Individual-Current_residence_address_state",
  "SC-Individual-Current_residence_address_country",
  "SC-Individual-Current_residence_address_postal",

  // Section I - Mailing Address
  "SC-Individual-Mailing_address_street",
  "SC-Individual-Mailing_address_city",
  "SC-Individual-Mailing_address_state",
  "SC-Individual-Mailing_address_country",
  "SC-Individual-Mailing_address_postal",

  // Section II - Tax Residency - Jurisdiction 1
  "SC-Individual-Tax_residency_country",
  "SC-Individual-Tax_reference_number_type",
  "SC-Individual-Tax_id",
  "SC-Individual-Tin_or_functional_equivalent",
  "SC-Individual-Reason_for_non_tin",
  "SC-Individual-Sole_residency_yes",
  "SC-Individual-Sole_residency_no",

  // Section II - Additional Jurisdictions (2-4)
  "sc_cp Jurisdiction 2",
  "sc_cp Tax Identification Number 2",
  "sc_cp Tax Reference Number Type 2",
  "sc_cp Reason for non-availability of TIN 2",

  "sc_cp Jurisdiction 3",
  "sc_cp Tax Identification Number 3",
  "sc_cp Tax Reference Number Type 3",
  "sc_cp Reason for non-availability of TIN 3",

  "sc_cp Jurisdiction 4",
  "sc_cp Tax Identification Number 4",
  "sc_cp Tax Reference Number Type 4",
  "sc_cp Reason for non-availability of TIN 4",

  // Section III - Declaration and Signature
  "SC-Individual-Signer_printed_name",
  "SC-Individual-Print_name",
  "SC-Individual-Date",
  "SC-Individual-Sign_date",
  "SC-Individual-Capacity",
  "SC-Individual-Signature_unreadable",
  "SC-Individual-Signature",
];

export const SELF_CERT_ENTITY_FIELD_ORDER = [
  // Unique Identifier
  "UniqueIdentifier",

  // Form Metadata
  "formType",
  "viewPdf",
  "Form Type",
  "Form_name",

  // Section I - Identification of Entity
  "SC-Entity-Section_1_entity_name",
  "SC-Entity-Section_1_org_country",

  // Section I - Current Residence Address
  "Permanent residence address",
  "SC-Entity-Section_1_current_residence_address_street",
  "SC-Entity-Section_1_current_residence_address_city",
  "SC-Entity-Section_1_current_residence_address_state",
  "SC-Entity-Section_1_current_residence_address_country",
  "Permanent address country",
  "SC-Entity-Section_1_current_residence_address_postal",

  // Section I - Mailing Address
  "Mailing address",
  "SC-Entity-Section_1_mailing_address_street",
  "Mailing address city",
  "SC-Entity-Section_1_mailing_address_city",
  "SC-Entity-Section_1_mailing_address_state",
  "SC-Entity-Section_1_mailing_address_country",
  "Mailing address country",
  "SC-Entity-Section_1_mailing_address_postal",

  // Section II - Tax Residency - Jurisdiction 1
  "SC-Entity-Section_2_tax_identification_country",
  "SC-Entity-Section_2_tax_reference_number_type",
  "SC-Entity-Section_2_tax_id",
  "SC-Entity-Section_2_unable_to_procure_a_tin",
  "SC-Entity-Section_2_reason_for_non_tin",
  "SC-Entity-Section_2_sole_residency_yes",
  "SC-Entity-Section_2_sole_residency_no",

  // Section II - Additional Tax Residencies (2-4)
  "sc_11 Jurisdiction of Tax Residence2",
  "sc_11 Tax Identification Number2",
  "sc_11 Tax Reference Number Type2",
  "sc_11 non-availability of TIN 2",

  "sc_11 Jurisdiction of Tax Residence3",
  "sc_11 Tax Identification Number3",
  "sc_11 Tax Reference Number Type3",
  "sc_11 non-availability of TIN 3",

  "sc_11 Jurisdiction of Tax Residence4",
  "sc_11 Tax Identification Number4",
  "sc_11 Tax Reference Number Type4",
  "sc_11 non-availability of TIN 4",

  // Section III - FATCA and CRS Classification - Financial Institution
  "SC-Entity-Section_3_financial_institution",
  "sc_8 Financial Institution",
  "SC-Entity-Section_3_fatca_purposes",
  "sc_8 GIIN for FATCA purposes",
  "SC-Entity-Section_3_reporting_financial_institution_under_crs",
  "sc_8a Reporting Financial",
  "SC-Entity-Section_3_non_financial_institution_under_crs",
  "sc_8b Non-Reporting",
  "SC-Entity-Section_3_goverment_entity",
  "sc_8 Governmental Entity",
  "SC-Entity-Section_3_international_org",
  "sc_8 International Organization",
  "SC-Entity-Section_3_central_bank",
  "sc_8 Central Bank",
  "SC-Entity-Section_3_broad_participation_retirement_fund",
  "sc_8 Broad Participation Retirement Fund",
  "SC-Entity-Section_3_narrow_participation_retirement_fund",
  "sc_8 Narrow Participation",
  "SC-Entity-Section_3_pension_fund",
  "sc_8 Pension Fund",
  "SC-Entity-Section_3_exempt_collective_investment",
  "sc_8 Exempt Collective",
  "SC-Entity-Section_3_trust_trustee",
  "sc_8 Trust whose trustee",
  "SC-Entity-Section_3_qualified_credit_card_issuer",
  "sc_8 Qualified Credit Card Issuer",
  "SC-Entity-Section_3_other_entity",
  "sc_8 Other Entity",
  "SC-Entity-Section_3_other_entity_specify",
  "sc_8 Other Entity Text",

  // Section III - Non-Financial Institution Resident
  "SC-Entity-Section_3_non_financial_institution_under_crs_resident",
  "SC-Entity-Section_3_investment_entity_managed_by_company_listed",
  "sc_10 Investment Entity managed by company listed",
  "SC-Entity-Section_3_investment_entity",
  "SC-Entity-Section_3_investment_entity_managed_by_widely_held_civ",
  "sc_10 Investment Entity managed by widely held investment vehicle",
  "SC-Entity-Section_3_investment_entity_managed_by_pension_fund",
  "sc_10 Investment Entity managed by pension fund",
  "SC-Entity-Section_3_other_investment_entity",
  "sc_10 Other Investment Entity",
  "SC-Entity-Section_3_non_financial_institution",

  // Section III - Investment Entity
  "sc_10 Investment Entity",
  "sc_10 Investment Entity managed by Financial Institution",
  "sc_10 Investment Entity managed by Non-Financial Entity",

  // Section III - Active Non-Financial Entity
  "SC-Entity-Section_3_active_nfe",
  "sc_9 Active Non-Financial Entity",
  "SC-Entity-Section_3_regularly_traded_corporation",
  "sc_9 Corporation traded",
  "SC-Entity-Section_3_stock_exchange_name",
  "sc_9 Stock exchange name",
  "SC-Entity-Section_3_regularly_traded_corporation_name",
  "sc_9 Related entity name",
  "SC-Entity-Section_3_active_nfe_goverment_entity",
  "sc_9 Governmental Entity",
  "SC-Entity-Section_3_active_nfe_international_org",
  "sc_9 International Organization",
  "SC-Entity-Section_3_active_nfe_other",
  "sc_9 Other Active NFE",

  // Section III - Passive Non-Financial Entity
  "SC-Entity-Section_3_passive_nfe",
  "sc_11 Passive Non-Financial Entity",

  // Section III - Other Classifications
  "sc_13 Non-Financial Institution",
  "sc_13 Active Non-Financial Entity",
  "sc_13 Passive Non-Financial Entity",
  "sc_14 Other Classification",
  "sc_14 Other Classification Text",

  // Section III - Controlling Persons (1-10)
  "SC-Entity-Controlling_person_1",
  "SC-Entity-Controlling_person_2",
  "SC-Entity-Controlling_person_3",
  "SC-Entity-Controlling_person_4",
  "SC-Entity-Controlling_person_5",
  "SC-Entity-Controlling_person_6",
  "SC-Entity-Controlling_person_7",
  "SC-Entity-Controlling_person_8",
  "SC-Entity-Controlling_person_9",
  "SC-Entity-Controlling_person_10",

  "SC-Entity-Section_4_signature",
  "SC-Entity-Section_4_signer_printed_name",
  "SC-Entity-Section_4_signature_date",
  "SC-Entity-Section_4_capacity",
  // Section III - Account Holders
  "sc_Account Holder1",
  "sc_Account Holder2",
  "sc_Account Holder3",
  "sc_Account Holder4",

  // Part IV - Controlling Person Details
  "SC-Entity-Legal_entity",
  "SC-Entity-Controlling_person_title",
  "SC-Entity-Controlling_person_last_name",
  "SC-Entity-Controlling_person_first_name",
  "SC-Entity-Controlling_person_middle_name",
  "SC-Entity-Controlling_person_city_of_birth",
  "SC-Entity-Controlling_person_country_of_birth",
  "SC-Entity-Controlling_person_dob",

  // Part IV - Controlling Person Current Address
  "SC-Entity-Controlling_person_address_street",
  "SC-Entity-Controlling_person_address_street2",
  "SC-Entity-Controlling_person_address_city",
  "SC-Entity-Controlling_person_address_state",
  "SC-Entity-Controlling_person_address_country",
  "SC-Entity-Controlling_person_address_postal",

  // Part IV - Controlling Person Mailing Address
  "SC-Entity-Controlling_person_mailing_address_street",
  "SC-Entity-Controlling_person_mailing_address_city",
  "SC-Entity-Controlling_person_mailing_address_state",
  "SC-Entity-Controlling_person_mailing_address_country",
  "SC-Entity-Controlling_person_mailing_address_postal",

  // Part IV - Type of Controlling Person
  "SC-Entity-Controlling_person_type_owner",
  "SC-Entity-Controlling_person_owner_percentage",
  "SC-Entity-Controlling_person_by_other_means",
  "SC-Entity-Controlling_person_senior_managing",

  // Part IV - Trust Options
  "SC-Entity-Controlling_person_settlor",
  "SC-Entity-Controlling_person_trustee",
  "SC-Entity-Controlling_person_protector",
  "SC-Entity-Controlling_person_beneficiary",
  "SC-Entity-Controlling_person_other",
  "SC-Entity-Controlling_person_other_specify",

  // Part IV - Legal Arrangement Equivalents
  "SC-Entity-Controlling_person_settlor_equivalent",
  "SC-Entity-Controlling_person_trustee_equivalent",
  "SC-Entity-Controlling_person_protector_equivalent",
  "SC-Entity-Controlling_person_beneficiary_equivalent",
  "SC-Entity-Controlling_person_other_equivalent",

  // Part IV - Controlling Person Tax Identification
  "SC-Entity-Section_4_jurisdiction_1",
  "SC-Entity-Section_4_tax_reference_number",
  "SC-Entity-Section_4_tax_id",
  "SC-Entity-Section_4_sole_residency_yes",
  "SC-Entity-Section_4_sole_residency_no",
  "SC-Entity-Section_4_unable_to_procure_tin",
  "SC-Entity-Section_4_reason_non_availability_of_tin",

  // Section IV - Declaration
  "sc_consent_to_information_sharing",
  "sc_agree_to_inform_changes",
  "sc_certify_account_holder",
  "sc_declare_statements_correct",

  "SC-Entity-Controlling_person_jurisdiction_2",
  "SC-Entity-Controlling_person_tax_reference_type_2",
  "SC-Entity-Controlling_person_tax_id_2",
  "SC-Entity-Controlling_person_tin_reason_2",
  "SC-Entity-Controlling_person_jurisdiction_3",
  "SC-Entity-Controlling_person_tax_reference_type_3",
  "SC-Entity-Controlling_person_tax_id_3",
  "SC-Entity-Controlling_person_tin_reason_3",
  "SC-Entity-Controlling_person_jurisdiction_4",
  "SC-Entity-Controlling_person_tax_reference_type_4",
  "SC-Entity-Controlling_person_tax_id_4",
  "SC-Entity-Controlling_person_tin_reason_4",
  // Section IV - Entity Signature
  "SC-Entity-isSigned",
  "SC-Entity-isModified",

  // Section V - Controlling Person Signature
  "SC-Entity-Section_5_signature",
  "SC-Entity-Section_5_signer_printed_name",
  "SC-Entity-Section_5_signature_date",
  "SC-Entity-Section_5_capacity",
];

/**
 * Get the field order for a specific form type
 */
export function getFormFieldOrder(formType: string): string[] {
  const normalizedType = (formType || "").toLowerCase().replace(/[-\s]/g, "");

  if (normalizedType.includes("w8ben") && !normalizedType.includes("bene")) {
    return W8BEN_FIELD_ORDER;
  }
  if (normalizedType.includes("w8bene") || normalizedType.includes("bene")) {
    return W8BENE_FIELD_ORDER;
  }
  if (normalizedType.includes("w9")) {
    return W9_FIELD_ORDER;
  }
  if (normalizedType.includes("w8imy")) {
    return W8IMY_FIELD_ORDER;
  }
  if (normalizedType.includes("w8eci")) {
    return W8ECI_FIELD_ORDER;
  }
  if (normalizedType.includes("w8exp")) {
    return W8EXP_FIELD_ORDER;
  }
  if (normalizedType.includes("8233")) {
    return FORM_8233_FIELD_ORDER;
  }
  if (
    normalizedType.includes("selfcertindividual") ||
    normalizedType.includes("selfcertind") ||
    (normalizedType.includes("selfcert") && normalizedType.includes("individual"))
  ) {
    return SELF_CERT_INDIVIDUAL_FIELD_ORDER;
  }
  if (
    normalizedType.includes("selfcertentity") ||
    normalizedType.includes("selfcertent") ||
    (normalizedType.includes("selfcert") && normalizedType.includes("entity"))
  ) {
    return SELF_CERT_ENTITY_FIELD_ORDER;
  }

  // Default: return empty array (will show all fields in Object.entries order)
  return [];
}

/**
 * Sort object entries by predefined field order
 */
export function sortByFieldOrder(entries: [string, any][], fieldOrder: string[]): [string, any][] {
  if (fieldOrder.length === 0) {
    return entries; // No order defined, return as-is
  }

  const ordered: [string, any][] = [];
  const remaining: [string, any][] = [];

  // First, add fields in the defined order
  fieldOrder.forEach((fieldName) => {
    const entry = entries.find(([key]) => key.toLowerCase() === fieldName.toLowerCase());
    if (entry) {
      ordered.push(entry);
    }
  });

  // Then, add any remaining fields that weren't in the order
  entries.forEach((entry) => {
    const [key] = entry;
    const isInOrder = fieldOrder.some((fieldName) => fieldName.toLowerCase() === key.toLowerCase());
    if (!isInOrder) {
      remaining.push(entry);
    }
  });

  return [...ordered, ...remaining];
}
